import { call, put, takeLatest, select } from 'redux-saga/effects';

import { userApi } from '../../../api';

import * as actions from './actions';

import { selectSecret } from '../../router/selectors';

function* newsletterOptin() {
  try {
    yield put({ type: actions.CONFIRM_NEWSLETTER_OPT_IN_PENDING });
    const secret = yield select(selectSecret);
    const { status } = yield call(userApi.newsletterOptin, { secret });

    if (status === 200) {
      yield put({ type: actions.CONFIRM_NEWSLETTER_OPT_IN_FULFILLED });
    }
  } catch (e) {
    yield put({ type: actions.CONFIRM_NEWSLETTER_OPT_IN_REJECTED, payload: e });
  }
}

export function* watchNewsletterOptin() {
  yield takeLatest(actions.CONFIRM_NEWSLETTER_OPT_IN, newsletterOptin);
}
